// extracted by mini-css-extract-plugin
export default {"root":"AutosBreadcrumbs-module-root"};